import { createFeature, createReducer, on } from '@ngrx/store';
import { setDisabled } from '../actions/messenger.actions';

export const MESSENGER_STATE_KEY = 'messenger';

export type MessengerState = {
  disabled: boolean;
};

const initialState: MessengerState = {
  disabled: true,
};

const reducer = createReducer(
  initialState,
  on(setDisabled, (state, { disabled = true }) => ({
    ...state,
    disabled: disabled,
  })),
);

export const messengerFeature = createFeature({
  name: MESSENGER_STATE_KEY,
  reducer,
});
